import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login-component/login-component.component';
import {  HeaderComponent } from './header-component/header-component.component';
import {  FooterComponent } from './footer-component/footer-component.component';
import { RegisterComponent} from './register-component/register-component.component';
import {  ForgotComponent } from './forgot-component/forgot-component.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as Parse from 'parse';
import { environment } from 'src/environments/environment.prod';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { AboutComponent } from './about/about.component';
import { QuestionaireModule } from './questionaire/questionaire.module';
import { LogsModule } from './logs/logs.module';
import { NgbdModalContent } from './alert-component';
import { RegisteredThanksComponent } from './registered-thanks/registered-thanks.component';
import { CookieService } from 'ngx-cookie-service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from './interceptor';


import {A11yModule} from '@angular/cdk/a11y';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule, MatCard} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import { Ng2SmartTableModule } from 'ng2-smart-table';
// import { NbThemeModule, NbLayoutModule } from '@nebular/theme';
// import { NbMenuModule } from '@nebular/theme';
import { SidenavComponent } from './sidenav/sidenav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { LogsCardComponent } from './logs-card/logs-card.component';
import { LogsDashboardComponent } from './logs-dashboard/logs-dashboard.component';
import { WeightTrendComponent } from './trends/weight-trend/weight-trend.component';
import { FoodTrendComponent } from './trends/food-trend/food-trend.component';
import { ActivityTrendComponent } from './trends/activity-trend/activity-trend.component';

import { FoodResultsComponent } from './logs/food-results/food-results.component';
import { HistoryComponent } from './histories/history/history.component';
import { FoodHistoryComponent } from './histories/food-history/food-history.component';
import { WeightHistoryComponent } from './histories/weight-history/weight-history.component';
import { PlansCardComponent } from './plans-card/plans-card.component';
import { PlansDashboardComponent } from './plans-dashboard/plans-dashboard.component';
import { TestTableComponent } from './histories/test-table/test-table.component';

// import { NbMenuModule, NbSidebarService } from '@nebular/theme';
// import { MatFormField } from '@angular/material';
import { PlansChecklistComponent } from './plans-checklist/plans-checklist.component';
import { FoodplanHistoryComponent } from './histories/foodplan-history/foodplan-history.component';
import { ActivityplanHistoryComponent } from './histories/activityplan-history/activityplan-history.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { DocweighttrendComponent } from './doctorview/docweighttrend/docweighttrend.component';
import { DocfoodtrendComponent } from './doctorview/docfoodtrend/docfoodtrend.component';
import { DocactivitytrendComponent } from './doctorview/docactivitytrend/docactivitytrend.component';
import { DoccardComponent } from './doccard/doccard.component';
import { DocdashboardComponent } from './docdashboard/docdashboard.component';
import { DocsummaryComponent } from './doctorview/docsummary/docsummary.component';
import { ProgramComponent } from './program/program.component';
import { CoachviewComponent } from './logs/coachview/coachview.component';
import { DeniedRegisterComponent } from './denied-register/denied-register.component';
import { CoachclassesComponent } from './coachclasses/coachclasses.component';
import { RecommendPatientComponent } from './recommend-patient/recommend-patient.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    RegisterComponent,
    ForgotComponent,
    HomeComponent,
    ContactComponent,
    AboutComponent,
    RegisteredThanksComponent,
    SidenavComponent,
    LogsCardComponent,
    LogsDashboardComponent,
    WeightTrendComponent,
    FoodTrendComponent,
    ActivityTrendComponent,
    HistoryComponent,
    FoodHistoryComponent,
    WeightHistoryComponent,
    PlansCardComponent,
    PlansDashboardComponent,
    TestTableComponent,
    PlansChecklistComponent,
    FoodplanHistoryComponent,
    ActivityplanHistoryComponent,
    AccountDetailsComponent,
    DocweighttrendComponent,
    DocfoodtrendComponent,
    DocactivitytrendComponent,
    DoccardComponent,
    DocdashboardComponent,
    DocsummaryComponent,
    ProgramComponent,
    DeniedRegisterComponent,
    CoachclassesComponent,
    RecommendPatientComponent,

  ],
  imports: [
    NgbModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    QuestionaireModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatButtonModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatDividerModule,
    MatMenuModule,
    MatTabsModule,
    MatTooltipModule,
    MatSortModule,
    MatFormFieldModule,
    MatPaginatorModule,
    Ng2SmartTableModule,
    LayoutModule,
    LogsModule,
    BrowserAnimationsModule,
    MatGridListModule,
    HttpClientModule,
    MatTableModule,
    MatExpansionModule,
    MatInputModule
  ],
  providers: [
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true }
  ],
  entryComponents: [LoginComponent, RegisterComponent, NgbdModalContent],
  bootstrap: [AppComponent],
  exports: [
    A11yModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,
  ]
})
export class AppModule { }
